import React from 'react';
import Login from './components/login';
import OrderFormRoot, { OrderFormProps } from './order_form/OrderFormRoot';
import AccountForm, { AccountFormProps } from './account/AccountForm';
import OrdersRoot, { OrdersRootProps } from './order_history/OrdersRoot';
import OrderRoot from './order_history/OrderRoot';
import OrderHistory from './order_history/OrderHistory';
import Snackbar, { SnackData } from './components/snackbar';
import wuid from './util/uid';
import { User } from './types/user';


export interface SubComponentProps {
  active: boolean;
  loading: boolean;
  user: User | undefined;
  navigate: AccountRoot["navigate"];
  setLoading: AccountRoot["setLoading"];
  callAPI: AccountRoot["callAPI"];
  addSnack: AccountRoot["addSnack"];
  convertWeight: AccountRoot["convertWeight"];
}


type ApiMethod = 'get' | 'post' | 'put' | 'delete';


export interface AccountRootProps {
  page: string;
  account_form_props: AccountFormProps;
  order_form_props: OrderFormProps;
  orders_props: OrdersRootProps;
  api_prefix?: string;
}


export interface AccountRootState {
  loading: boolean;
  user: User | undefined;
  pageEls: string[];
  page: string;
  snacks: SnackData[];
  login_failed: boolean;
  magic_token: string | undefined;
  FC: any | undefined;
  show_pricing_modal: boolean;
}


const basePath = '/order';


class AccountRoot extends React.Component<AccountRootProps, AccountRootState> {


  state: AccountRootState;
  _login_failed: boolean = false;
  _magic_token: string | undefined = undefined;


  constructor(props:AccountRootProps) {

    super(props);

    let pageels = this.getPageFromLocation()
    let currpage = pageels[0] || 'neworder';

    const defState = this.state = {
      loading: true,
      user: undefined,
      pageEls: pageels,
      page: currpage,
      snacks: [],
      login_failed: this._login_failed,
      magic_token: this._magic_token,
      FC: undefined,
      show_pricing_modal: false
    };


    // detect the loading of the foxy object so we can pass it to the orderform
    (window as any).FC = (window as any).FC || {};
    (window as any).FC.onLoad = () => {
      (window as any).FC.client.on('ready.done', () => {
        this.setState({
          FC: (window as any).FC
        })
      });
    };

    window.onpopstate = (e: any) => {
      let pageels = this.getPageFromLocation();
      let toPage = pageels[0] || 'neworder';
      this.setState({
        pageEls: pageels,
        page: toPage,
      })
    };

    this.getPageFromLocation = this.getPageFromLocation.bind(this);
    this.navigate = this.navigate.bind(this);
    this.setLoading = this.setLoading.bind(this);
    this.callAPI = this.callAPI.bind(this);
    this.setUser = this.setUser.bind(this);
    this.addSnack = this.addSnack.bind(this);
    this.deleteSnack = this.deleteSnack.bind(this);
  }


  componentDidMount() {
    this.fetchUser();
  }


  render() {
    return (
    <React.Fragment>
      <div id="AccountRootTop"></div>
      {this.mainApp}
      <Snackbar snacks={this.state.snacks} deleteSnack={this.deleteSnack} />
    </React.Fragment>
    );
  }


  get mainApp() {
    let baseProps = {
      loading: this.state.loading,
      user: this.state.user,
      navigate: this.navigate,
      setLoading: this.setLoading,
      callAPI: this.callAPI,
      addSnack: this.addSnack,
      convertWeight: this.convertWeight,
    };

    return (
      <div>
        <div className="AccountPage">

          <div className={'loading-cover' + (this.state.loading ? ' active' : '')}>
            <div className="spinner">
              <i className="fa fa-spinner fa-pulse fa-4x fa-fw"></i>
            </div>
          </div>

          <div className={"SubPage" + (this.state.page === "neworder" ? " active" : " inactive")}>
            <OrderFormRoot { ...{ ...this.props.order_form_props, ...baseProps, active: this.state.page === "neworder" }} FC={this.state.FC} />
          </div>

          <div className={"SubPage" + (this.state.page === "order" ? " active" : " inactive")}>
            <OrderRoot { ...{ ident: this.state.pageEls[1] || '', sec_key: this.state.pageEls[2] || '', ...baseProps, active: this.state.page === "order"} } />
          </div>

        </div>        

      </div>
    )
  }


  async callAPI(method: ApiMethod, path: string, data?: any): Promise<any> {

    try {
      const init: RequestInit = {
        method: method,
        credentials: 'include', 
        redirect: 'follow'
      };
      const headers: any = {};

      if (data) {
        headers['Content-Type'] = 'application/json';
        init.headers = {
          'Content-Type': 'application/json',
        };
        init.body = JSON.stringify(data);
      }

      const pfx = this.props.api_prefix || "";
      let response = await fetch(pfx+'/order/_api_pub'+path, init);

      if (response.ok) {
        const res = await response.json();
        return res.data;
      } else {
        if (response.status === 403) {
          this.navigate('login');
        } else {
          return false;
        }
      }

    } catch(e) {
      // nothin here
      return false;
    }
  }

  
  async fetchUser() {
    this.setState({
      loading: false,
    });
  }


  getPageFromLocation(): string[] {
    // strip off the basePath
    let path = window.location.pathname;
    if (path.substr(0, basePath.length) === basePath) {
      path = path.substr(basePath.length);
    }

    let els = path.split('/');
    els.shift();

    const url = new URL(window.location.href);

    // check for a magic link
    if (url.searchParams.get('m')) {
      this._magic_token = url.searchParams.get('m')+"";
    }

    // check for login failure
    if (els[0] === 'login') {
      if (url.searchParams.get('f')) {
        this._login_failed = true;
      }
    }

    return els;
  }


  navigate(toPage: string | string[]): void {
    if (Array.isArray(toPage)) {

      let p = toPage[0];
      this.setState({
        pageEls: toPage,
        page: p,
      })
      window.history.pushState({}, '', `${basePath}/${toPage.join('/')}`);

    } else {

      this.setState({
        pageEls: [ toPage ],
        page: toPage,
      });
      window.history.pushState({}, '', `${basePath}/${toPage}`);

    }
  }


  setLoading(loading: boolean) {
    this.setState({
      loading: loading,
    });
  }


  setUser(user: User) {
    this.setState({
      user: user,
    })
  }

  
  addSnack(snack: Partial<SnackData>) {
    let ss = [...this.state.snacks];
    snack.uid = wuid();
    ss.push((snack as SnackData));
    this.setState({
      snacks: ss,
    });
  }


  deleteSnack(snackid: string) {
    let ss = [...this.state.snacks];
    ss = ss.filter(s => s.uid !== snackid);

    this.setState({
      snacks: ss,
    });
  }


  convertWeight(w: number | '', blanks = false): [number | '', number | ''] {
    let weight_lbs: '' | number = '';
    let weight_oz: '' | number = '';

    if (w !== '') {
      weight_lbs = Math.floor(w / 16);
      weight_oz = w - (Math.floor(w / 16) * 16);

      if (blanks) {
        return [weight_lbs > 0 ? weight_lbs : '', weight_oz > 0 ? weight_oz : ''];
      } else {
        return [weight_lbs, weight_oz];
      }

    } else {
      if (blanks) {
        return ['', ''];
      } else {
        return [0, 0];
      }
    }

  }

}


export default AccountRoot;
